module.exports = __webpack_public_path__ + "static/img/pinJie5.c704e49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pinJie5.png
// module id = e5y6
// module chunks = 2